import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { isPlausiblePublicToken, fetchWithTimeout } from '@core/utils/publicToken';

/**
 * Open-tracking pixel endpoint.
 * When an email client loads this page (via the 1×1 img tag),
 * we call the Edge Function to record the open event, then
 * respond with a transparent 1×1 GIF.
 *
 * In practice the <img> tag in the email HTML points directly to the
 * Edge Function URL — this React page is a fallback for non-img loads.
 */
export function TrackPage() {
  const { token } = useParams<{ token: string }>();

  useEffect(() => {
    if (!token || !isPlausiblePublicToken(token)) return;
    fetchWithTimeout(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/ggj_b2b_track-email-open?token=${encodeURIComponent(token)}`,
      {
        method: 'GET',
        headers: { apikey: import.meta.env.VITE_SUPABASE_ANON_KEY },
        keepalive: true,
        timeoutMs: 15_000,
      }
    ).catch(() => {/* silently ignore */});
  }, [token]);

  // Return a 1×1 transparent pixel as the page content
  return (
    <div style={{ width: 1, height: 1, overflow: 'hidden', opacity: 0 }} aria-hidden />
  );
}
